import { productNew,getPVUV } from '@apis/apis'
import Head from '@wigets/head.vue'
import Foot from '@wigets/foot.vue'
export default {
  components: {
    "web-head": Head,
    "web-foot": Foot,
  },
  data() {
    return {
      productNews: {},
      tab: 4,
    };
  },
  created() {
    this.getproduct();
    this.getpvuv()
  },
  computed: {
    // 计算是否有店铺链接
    storeLink() {
      return (url) => {
        if(!url) {
          return false
        } else {
          return true
        }
      }
    }
  },
  methods: {
    changeTab(val) {
      this.tab = val;
    },
    // 埋点
    getpvuv(){
      this.$ajaxPost(getPVUV,{
        ip: sessionStorage.getItem('ip'),
        directoryOne: "电商优选",
        directoryTwo: '商品详情',
        directoryThree: null,
        cookie: sessionStorage.getItem('random')
      })
    },
    /**
     *  获取指定id的商品详情
     * @param {*}
     * @param {*}
     */
    getproduct() {
      if (!this.$route.query.id) {
        return this.$router.push({ name: "preferred" });
      }
      let id = this.$route.query.id;
      this.$ajaxGet(`${productNew}/${id}`, {})
        .then((res) => {
          if (res.data.code != 0) {
            this.$message({
              title: "错误",
              type: "error",
              message: res.data.msg + ",请重新刷新",
            });
          }
          this.productNews = res.data.data;
          while (this.productNews.content.indexOf("&amp") !== -1) {
            this.productNews.content = this.showcontent(
              this.productNews.content
            );
          }
        })
        .catch((err) => {
          this.$alert(err + "网络请求异常，请稍后再试！", "警告", {
            confirmButtonText: "确定",
            type: "error",
            callback: () => {
              location.reload();
            },
          });
        });
    },
    //点击位置导航进行跳转
    navPosition(name) {
      this.$router.push({ name });
    },

    /**
     *  内容转义
     * @param {*}
     * @param {*}
     */
    showcontent(str) {
      if (!str) {
        return;
      }
      let arrEntities = { lt: "<", gt: ">", nbsp: " ", amp: "&", quot: '"' };
      return str.replace(/&(lt|gt|nbsp|amp|quot);/gi, function(all, t) {
        return arrEntities[t];
      });
    },
    // 点击跳转按钮跳转到店铺
    goStore(url) {
      if(url === '' || url === null){
        return this.alertInfo();
      } else{
        window.location.href = url
      }
      // window.open(url)
    },
    // 没有跳转链接的提示信息
    alertInfo() {
      this.$confirm("该商品暂无店铺链接!", "提示", {
        confirmButtonText: "确定",
        type: "warning",
        showCancelButton: false
      });
    }
  },
};